define('modules/form_editor/models/custom_password',['require','exports','module','./base_form_element'],function(require, exports, module){
  "use strict";
  var BaseFormElement = require("./base_form_element");
  module.exports = BaseFormElement.extend({
    name: "custom:password",
    defaultValues: {
      "placeholder": "",
      "variable": "",
      "confirmation": false,
      "confirmationLabel": "",
      "confirmationPlaceholder": "",
      "confirmationDifferentMessage": ""
    },
    defaultErrorMsgKey: "formEditor.validationMessages.password",
  });
});

